<template>
	<div class="flex justify-start w-full">
		<div v-if="step === 1" class="w-full">
			<div class="mb-4 font-bold flex justify-center">{{ $t('take_photos_of_damaged_parts') }}</div>
			<div class="w-full gap-6">
				<div class="box-border p-4 border-2 border-gray-300 bg-gray-100 cursor-pointer justify-start flex" v-if="isImageContent">
					<div :style="{ backgroundImage: 'url(' + this.image.base64Content + ')' }" class="w-full bg-cover bg-center h-64 relative text-right"></div>
				</div>
				<div class="flex flex-grow justify-center">
					<BaseCamera
						ref="RepairExtension.BaseCamera"
						class="flex justify-start items-center"
						:disable-success-message="true"
						:enable-preview="false"
						:label="getBaseCameraLabel"
						:app-mode="true"
						@snapshot="snapshotCam($event)"
						:allow-upload-in-app-container="false"
					></BaseCamera>
				</div>
			</div>
			<div class="flex justify-end">
				<BaseButton class="mt-6 w-full btn-blue" v-if="isUploadButtonActive" @click="nextStep">
					{{ getUploadButtonLabel }}
				</BaseButton>
			</div>
		</div>

		<div v-if="step === 2" class="w-full">
			<div class="mb-4 font-bold justify-center flex">{{ $t('description_of_damage') }}</div>
			<div class="box-border p-4 pb-0 border-2 border-gray-300 bg-gray-100 w-full">
				<BaseInput class="ma-0 pa-0">
					<textarea class="w-full shadow-m" v-model="damageDescription"></textarea>
				</BaseInput>
			</div>
			<div class="flex justify-end">
				<BaseButton class="mt-6 w-full btn-blue" v-if="isUploadButtonActive" @click="save">{{ $t('apply_repair_extension_short') }}</BaseButton>
			</div>
		</div>
	</div>
</template>

<script>
import BaseButton from '@/components/forms/buttons/BaseButton';
import BaseCamera from '@/components/forms/inputs/BaseCamera';
import { AppsEmployeeApiFactory } from '@/api/generated';
import apiDefaults from '@/api/defaultConfiguration';
import BaseInput from '@/components/forms/inputs/BaseInput';
import LoadingSpinner from '@/mixins/LoadingSpinner';
import AppContainerMixin from '@/mixins/AppContainerMixin';

export default {
	name: 'AppsEmployeeRepairExtension',
	components: { BaseInput, BaseButton, BaseCamera },
	mixins: [LoadingSpinner, AppContainerMixin],
	data() {
		return {
			damageDescription: null,
			imageList: [],
			image: {
				base64Content: null,
			},
			baseCameraLabel: this.$t('take_picture'),
			isUploadButtonActive: false,
			showUploadSuccess: false,
			step: 1,
		};
	},
	computed: {
		getBaseCameraLabel() {
			return this.baseCameraLabel;
		},
		isImageContent() {
			return this.image.base64Content !== null;
		},
		getImageListCount() {
			return this.imageList.length;
		},
		getUploadButtonLabel() {
			return 'Weiter (' + this.getImageListCount + ' ' + (this.getImageListCount === 1 ? this.$t('photo') : this.$t('photos')) + ')';
		},
	},
	methods: {
		openUpload() {
			if (window.appcontainer.isiOSAppcontainer) {
				this.$refs['Workingimages.BaseCamera'].openCamera();
			} else {
				this.$refs['Workingimages.BaseCamera'].openUpload();
			}
		},
		snapshotCam(event) {
			this.showUploadSuccess = false;
			this.imageList.push({
				type: 'image',
				base64Content: event,
			});
			this.image.base64Content = event;
			this.baseCameraLabel = this.$t('add_another_photo');
			this.isUploadButtonActive = true;
		},
		nextStep() {
			window.scrollTo({ top: 0 });
			this.$emit('scrollUp');
			this.step++;
		},
		save() {
			this.setLoadingStatus(true);
			AppsEmployeeApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
				.appsEmployeeRepairextensionPost({ description: this.damageDescription, images: this.imageList })
				.then(result => {
					this.showUploadSuccess = true;
					this.setLoadingStatus(false);
					this.$swal({
						title: this.$t('general.success').toString(),
						text: this.$t('repair_extension_applied').toString(),
						icon: 'success'
					}).then(_ => {
						this.$router.push({ name: 'AppsEmployeeMain' });
					});
				})
				.catch(error => {
					this.setLoadingStatus(false);
				});
		},
	},
};
</script>

<style scoped></style>
